module.exports = __webpack_public_path__ + "img/avatar.0036f290.svg";